import { Action } from "redux";

export const CHANGE_TYPE_CHANGED = "CHANGE_TYPE_CHANGED";

export interface UpdateChangesTypesAction extends Action {
    changeType: string;
    value: boolean;
}

export const updateChangesTypesAction = (changeType: string, value: boolean): UpdateChangesTypesAction => {
    return {
        type: CHANGE_TYPE_CHANGED,
        changeType: changeType,
        value: value,
    };
};
